import React from 'react';
import MaskedInput from 'react-text-mask';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import Input from '@material-ui/core/Input';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

function TextMaskCustom(props) {
    const { inputRef, ...other } = props;

    return (
        <MaskedInput
            {...other}
            ref={inputRef}
            mask={[/[0-3]/, /\d/, '/', /[0-1]/, /\d/]}
            placeholderChar={'\u2000'}
            showMask
        />
    );
}

TextMaskCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
};

class DayMonth extends React.Component {
    state = {
        value: this.props.value,
        error: false,
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ value: nextProps.value });
    }

    handleChange = (name) => (event) => {
        const value = event.target.value;
        const error =
            value &&
            value.length === 5 &&
            (parseInt(value.split('/')[0], 10) > 31 ||
                parseInt(value.split('/')[0], 10) === 0 ||
                parseInt(value.split('/')[1], 10) > 12 ||
                parseInt(value.split('/')[1], 10) === 0);
        this.setState({ value: value });
        this.props.handleChange(value, error);
    };

    render() {
        const { error } = this.state;

        return (
            <FormControl error={error} className="flex_full_row">
                <Input
                    value={this.props.value}
                    onChange={this.handleChange('value')}
                    id="day-month-input"
                    inputComponent={TextMaskCustom}
                />
                {error && (
                    <FormHelperText id="name-helper-text">
                        <FormattedMessage id={'date_field_error_format'} />
                    </FormHelperText>
                )}
            </FormControl>
        );
    }
}

export default DayMonth;



// WEBPACK FOOTER //
// ./src/components/inputs/DayMonth.js